import { isEmpty } from 'lodash';
import { TBaseCommentProps, TCommentProps } from '../CommentsList';

export const mapT2Comments = (
  t2Comments: TBaseCommentProps[] | undefined,
  userId: string | undefined,
  addLike: Function,
  removeLike: Function,
): TCommentProps[] | undefined =>
  t2Comments?.map((comment) => {
    const userAlreadyLikedComment = !!(userId && !isEmpty(comment.likes));

    const toggleLike = async (): Promise<void> => {
      const toggle = userAlreadyLikedComment ? removeLike : addLike;
      return await toggle({
        variables: {
          commentId: comment.id,
        },
      });
    };

    return {
      ...comment,
      userAlreadyLikedComment,
      updateLike: toggleLike,
      origin: 't2',
    };
  });
